/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { TimeSlotCardTimeSlotFragmentDoc } from './TimeSlotCard.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type TimeSlotPickerModalTimeSlotFragment = { startsAt: TimeString, endsAt: TimeString };

export type TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables = Exact<{
  from: TimeString;
  until: TimeString;
}>;


export type TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery = { availableBookingRequestTimeSlots:
    | { __typename: 'AvailableBookingRequestTimeSlotsErrorInvalidCalendarConnection', message: string }
    | { __typename: 'AvailableBookingRequestTimeSlotsErrorNoCalendarConnected', message: string }
    | { __typename: 'AvailableBookingRequestTimeSlotsSuccess', timeSlots: Array<{ startsAt: TimeString, endsAt: TimeString }> }
   };

export const TimeSlotPickerModalTimeSlotFragmentDoc = gql`
    fragment TimeSlotPickerModalTimeSlot on TimeSlot {
  ...TimeSlotCardTimeSlot
}
    ${TimeSlotCardTimeSlotFragmentDoc}`;
export const TimeSlotPickerModalAvailableBookingRequestTimeSlotsDocument = gql`
    query TimeSlotPickerModalAvailableBookingRequestTimeSlots($from: Time!, $until: Time!) {
  availableBookingRequestTimeSlots(from: $from, until: $until) {
    __typename
    ... on AvailableBookingRequestTimeSlotsSuccess {
      timeSlots {
        startsAt
        endsAt
      }
    }
    ... on AvailableBookingRequestTimeSlotsErrorNoCalendarConnected {
      message
    }
    ... on AvailableBookingRequestTimeSlotsErrorInvalidCalendarConnection {
      message
    }
  }
}
    `;

/**
 * __useTimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery__
 *
 * To run a query within a Vue component, call `useTimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery({
 *   from: // value for 'from'
 *   until: // value for 'until'
 * });
 */
export function useTimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery(variables: TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables | VueCompositionApi.Ref<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables> | ReactiveFunction<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>(TimeSlotPickerModalAvailableBookingRequestTimeSlotsDocument, variables, options);
}
export function useTimeSlotPickerModalAvailableBookingRequestTimeSlotsLazyQuery(variables?: TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables | VueCompositionApi.Ref<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables> | ReactiveFunction<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>(TimeSlotPickerModalAvailableBookingRequestTimeSlotsDocument, variables, options);
}
export type TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TimeSlotPickerModalAvailableBookingRequestTimeSlotsQuery, TimeSlotPickerModalAvailableBookingRequestTimeSlotsQueryVariables>;